// mapping actions

import { Action } from '@ngrx/store';

import { Mapped, MapperViewer, MappingOptions, MappingSetup, MasterModel } from '@usimweb/core/models';

export const LOAD_MAPPING = '[MAPPER] Load material';
export const LOAD_MAPPING_FAIL = '[MAPPER] Load material Fail';
export const LOAD_MAPPING_SUCCESS = '[MAPPER] Load material Success';

export const LOAD_MASTER_MODEL = '[MAPPER] Load master model';
export const LOAD_MASTER_MODEL_FAIL = '[MAPPER] Load master model Fail';
export const LOAD_MASTER_MODEL_SUCCES = '[MAPPER] Load master model Success';

export const UPDATE_MAPPING_OPTIONS = '[Mapper] Updated Mapping options';
export const UPDATE_MAPPING_SETUP = '[Mapper] Updated Mapping setup';
export const UPDATE_MAPPING_VIEW = '[Mapper] Updated Mapping view';
export const UPDATE_MASTER_MODEL = '[Mapper] Updated Master model parts';

export const CLEAR_MAPPING = '[Mapper] Clear mapping';

export class LoadMapping implements Action {
  readonly type = LOAD_MAPPING;
  constructor(public payload: string) {}
}

export class LoadMappingFail implements Action {
  readonly type = LOAD_MAPPING_FAIL;
  constructor(public payload: any) {}
}

export class LoadMappingSuccess implements Action {
  readonly type = LOAD_MAPPING_SUCCESS;
  constructor(public payload: Mapped) {}
}

export class LoadMasterModel implements Action {
  readonly type = LOAD_MASTER_MODEL;
  constructor(public payload: MasterModel) {}
}

export class LoadMasterModelFail implements Action {
  readonly type = LOAD_MASTER_MODEL_FAIL;
  constructor(public payload: any) {}
}

export class LoadMasterModelSuccess implements Action {
  readonly type = LOAD_MASTER_MODEL_SUCCES;
  constructor(public payload: MasterModel) {}
}

export class UpdateMappingOptions implements Action {
  readonly type = UPDATE_MAPPING_OPTIONS;
  constructor(public payload: MappingOptions) {}
}

export class UpdateMappingSetup implements Action {
  readonly type = UPDATE_MAPPING_SETUP;
  constructor(public payload: { id: string; updates: Partial<MappingSetup> }) {}
}

export class UpdateMasterModel implements Action {
  readonly type = UPDATE_MASTER_MODEL;
  constructor(public payload: Partial<MasterModel>) {}
}

export class UpdateMappingView implements Action {
  readonly type = UPDATE_MAPPING_VIEW;
  constructor(public payload: Partial<MapperViewer>) {}
}

export class ClearMapping implements Action {
  readonly type = CLEAR_MAPPING;
}

export type MappingAction =
  | LoadMapping
  | LoadMappingFail
  | LoadMappingSuccess
  | LoadMasterModel
  | LoadMappingFail
  | LoadMasterModelSuccess
  | UpdateMappingOptions
  | UpdateMappingSetup
  | UpdateMappingView
  | UpdateMasterModel
  | ClearMapping;
